import { createStore } from '@store/createStore';

const manageTranslationsInitialState = {
  search: '',
  selectedLanguage: null,
};

const useManageTranslationsStore = createStore((set) => ({
  ...manageTranslationsInitialState,
  actions: {
    setManageTranslationsInitialState: () => set({ ...manageTranslationsInitialState }),
    setManageTranslationsSearchValue: (search) => set({ search }),
    setManageTranslationsSelectedLanguage: (selectedLanguage) => set({ selectedLanguage }),
  },
}));

export const useManageTranslationsActions = () => useManageTranslationsStore((state) => state.actions);

export const selectManageTranslationsSearchValue = () => useManageTranslationsStore((state) => state.search);
export const selectManageTranslationsSelectedLanguage = () =>
  useManageTranslationsStore((state) => state.selectedLanguage);
